<h2 class="rs-tit3">
  {{ "modem-choice.ont-title" | translate }}
</h2>
<p>
  {{ "modem-choice.ont-description" | translate }}
</p>
<div class="rs-me"></div>
<div class="rs-flex-row rs-xpandgrid">
  <mprd-modem-choice-ont
    *ngFor="let ont of line.devices"
    [id]="ont.ncName"
    class="rs-flex-columns small-12 medium-4"
    [active]="ont.active"
    [activable]="line.devices.length > 1"
    [provider]="ont.providedBy"
    [serialNumber]="ont.serialNumber"
    [accessType]="ont.accessType"
    (activated)="onActivated(ont.ncName, $event)"
    (edited)="onOpenEditModal(ont.ncName)"
    (deleted)="onOpenDeleteModal(ont.ncName)"
  ></mprd-modem-choice-ont>
</div>
<div class="rs-me"></div>
<button
  class="rs-btn"
  [disabled]="line.devices.length > 1"
  (click)="onOpenAddModal()"
>
  {{ "modem-choice.ont-add" | translate }}
</button>
<div class="rs-me"></div>

<mprd-loading-modal
  *ngIf="pending"
  [message]="'modem-choice.ont-activation-pending' | translate"
></mprd-loading-modal>
